import fetchManager from '@utils/fetchManager'
import { getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  validarCertificado: async (token) => {
    const options = {
      headers: {
        signature: token
      }
    }
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/folio/certificate`, options)
    return response
  },
}
